import { globalStyleSheet } from '../assets/css/global.js';
/** @deprecated */
export class BaseClass extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [
            globalStyleSheet,
        ];
    }
    $(...args) {
        return this.shadowRoot.querySelector(...args);
    }
    $$(...args) {
        return this.shadowRoot.querySelectorAll(...args);
    }
}
